module.exports = __webpack_public_path__ + "img/paragraph-right-align.94b50c42.svg";